import { computed } from 'vue';
import { useColorMode } from '@vueuse/core';

/**
 * Composable to manage Monaco Editor theme based on the current shadcn theme
 *
 * @param {Object} options - Configuration options
 * @param {string} options.customLightTheme - Custom light theme name (defaults to 'vs')
 * @param {string} options.customDarkTheme - Custom dark theme name (defaults to 'vs-dark')
 * @returns {Object} - Theme utilities
 */
export function useMonacoTheme(options = {}) {
    const { customLightTheme = 'vs', customDarkTheme = 'vs-dark' } = options;
    const mode = useColorMode();

    /**
     * Reactive Monaco theme that automatically switches between light/dark
     */
    const monacoTheme = computed(() => {
        return mode.value === 'dark' ? customDarkTheme : customLightTheme;
    });

    /**
     * Boolean indicating if dark mode is currently active
     */
    const isDark = computed(() => mode.value === 'dark');

    /**
     * Boolean indicating if light mode is currently active
     */
    const isLight = computed(() => mode.value === 'light');

    return {
        monacoTheme,
        isDark,
        isLight,
        mode
    };
}